import React from 'react';
import { Player } from '../../types';
import { useAuth } from '../../context/AuthContext';

interface BannedScreenProps {
    userData: Player;
}

export const BannedScreen: React.FC<BannedScreenProps> = ({ userData }) => {
    const { logout } = useAuth();
    const banDetails = (userData as any).banDetails;

    return (
        <div className="min-h-screen bg-bg-dark flex items-center justify-center p-4">
            <div className="bg-surface-1 max-w-md w-full rounded-2xl border border-glass-border p-8 text-center space-y-6 shadow-2xl">
                <div className="w-20 h-20 rounded-full bg-danger/20 flex items-center justify-center mx-auto animate-pulse">
                    <span className="material-symbols-outlined text-4xl text-danger">gavel</span>
                </div>

                <div className="space-y-2">
                    <h1 className="text-2xl font-bold text-white">Compte Suspendu</h1>
                    <p className="text-text-secondary">
                        L'accès à votre compte a été restreint par un administrateur.
                    </p>
                </div>

                <div className="bg-surface-2 rounded-xl p-4 text-left space-y-3 border border-glass-border">
                    <div>
                        <span className="text-xs font-medium text-text-secondary uppercase tracking-wider block mb-1">Motif</span>
                        <p className="text-white font-medium">{banDetails?.reason || "Aucun motif spécifié"}</p>
                    </div>

                    <div className="h-px bg-glass-border" />

                    <div>
                        <span className="text-xs font-medium text-text-secondary uppercase tracking-wider block mb-1">Durée</span>
                        <p className="text-white font-medium">
                            {banDetails?.expiry ? (
                                <>Jusqu'au {new Date(banDetails.expiry).toLocaleDateString('fr-FR', { day: 'numeric', month: 'long', year: 'numeric', hour: '2-digit', minute: '2-digit' })}</>
                            ) : (
                                "Définitif"
                            )}
                        </p>
                    </div>
                </div>

                <button
                    onClick={() => logout()}
                    className="w-full bg-surface-3 hover:bg-surface-hover text-white py-3 rounded-lg font-medium transition-colors border border-glass-border"
                >
                    Se déconnecter
                </button>
            </div>
        </div>
    );
};
